<template>
	<div v-if="product" class="pt-16">
		<!-- This is the header image and title for each page -->
		<div class="w-full flex flex-col items-center justify-center bg-gradient-to-b from-ihh-pink to-ihh-purple py-20">
			<div class="max-w-8xl w-full justify-center">
				<div class="m-auto grid grid-cols-2 flex-inline px-4 pb-4">
					<div class="my-auto">
						<div class="text-2xl capitalize font-semibold text-ihh-midnight-gray flex w-full">
							<div v-if="product.reviewsCount">{{ product.reviewsCount }} Reviews</div>
							<div v-else class="flex w-full">No Reviews - Be the First!</div>
						</div>
					</div>
					<div class="flex w-full justify-end">
						<button
							@click="showReview = true"
							class="flex text-sm text-ihh-midnight-gray border-2 border-ihh-salmon px-8 py-3 rounded-lg hover:bg-ihh-salmon delay-100 whitespace-nowrap font-semibold"
						>
							Write a Review
						</button>
					</div>
				</div>
				<Modal v-if="showReview" @hide="closeReviewForm" maxWidth="max-w-4xl">
					<ReviewForm @close-review="closeReviewForm" @review-submitted="addReview" :product="product" />
				</Modal>
				<ReviewList :reviews="reviews" />
			</div>
		</div>
	</div>
</template>

<script>
import Mango from '../../../helpers/mango'
import Modal from '../../layout/modal.vue'
import ReviewForm from './review-form.vue'
import ReviewList from './review-list.vue'

export default {
	props: ['product', 'openReview'],
	components: { ReviewForm, ReviewList, Modal },
	data() {
		return {
			reviews: [],
			showReview: false,
			showDownloads: null,
			currentReview: 0,
			newReview: {
				reviewer: '',
				services: [],
				date: '',
			},
		}
	},
	watch: {
		openReview: {
			immediate: true,
			handler(value) {
				if (value) {
					this.showReview = true
				}
			},
		},
		showReview(value) {
			if (!value) {
				this.$emit('close-review')
			}
		},
	},
	async created() {
		if (!this.product?.id) return
		this.reviews = await Mango.reviews({ limit: 100, search: { productId: this.product.id, status: 'approved' }, sort: { date_reviewed: -1 } })
	},
	mounted() {
		setInterval(() => {
			this.currentReview = (this.currentReview + 1) % 3
		}, 15000)
	},
	methods: {
		closeReviewForm() {
			this.showReview = false
			this.$emit('close-review')
		},
		addReview(review) {
			review.dateModified = new Date().toISOString()
			//this.reviews.push(review) // review needs to be approved first
		},
	},
	computed: {
		reviewCountText() {
			const count = this.reviews.length
			return count === 0 ? 'No Reviews' : `${count} Review${count > 1 ? 's' : ''}`
		},
	},
}
</script>
